
  (function(){

    function bnstGet(){
      return {
        overlay: document.getElementById('bnstSupportOverlay'),
        launcher: document.querySelector('#bnstSupportWidget .bnst-launcher')
      };
    }

    window.bnstSupportToggle = function(force){

      var els = bnstGet();

      if(!els.overlay || !els.launcher) return;

      var isOpen =
        els.overlay.classList.contains('bnst-open');

      var nextOpen =
        (typeof force === 'boolean')
          ? force
          : !isOpen;

      if(nextOpen){

        els.overlay.classList.add('bnst-open');

        els.overlay.setAttribute(
          'aria-hidden',
          'false'
        );

        els.launcher.classList.add('bnst-open');
        els.launcher.classList.add('bnst-hide');

        els.launcher.setAttribute(
          'aria-expanded',
          'true'
        );

        document.body.style.overflow = 'hidden';

      } else {

        els.overlay.classList.remove('bnst-open');

        els.overlay.setAttribute(
          'aria-hidden',
          'true'
        );

        els.launcher.classList.remove('bnst-open');
        els.launcher.classList.remove('bnst-hide');

        els.launcher.setAttribute(
          'aria-expanded',
          'false'
        );

        document.body.style.overflow = '';
      }

    };

    window.bnstToggleAnswer = function(btn){

      if(!btn) return;

      var list =
        document.getElementById('bnstFaqList');

      if(!list) return;

      var opened =
        list.querySelectorAll('.bnst-q.bnst-open');

      opened.forEach(function(el){

        if(el !== btn){
          el.classList.remove('bnst-open');
        }

      });

      btn.classList.toggle('bnst-open');
    };

    window.bnstOpenWhatsapp = function(e){

      if(e){
        e.preventDefault();
      }

      var a = document.getElementById('bnstWhatsappBtn'); if (!a) return; a.href = 'mailto:vivarrosoporte@gmail.com?subject=Consulta%20Vivarro'; window.location.href = a.href;

    };

    /* ============ SERVICE STATUS ============ */
    /* Active hours: Sunday-Thursday, 10:00-18:00 local time */

    function bnstUpdateServiceStatus(){

      var bar =
        document.getElementById('bnstStatusBar');

      if(!bar) return;

      var now = new Date();

      var day = now.getDay();

      var mins =
        now.getHours() * 60 +
        now.getMinutes();

      var isActiveDay =
        day >= 1 &&
        day <= 5;

      var isActiveHour =
        mins >= 10 * 60 &&
        mins < 18 * 60;

      var isOpen =
        isActiveDay &&
        isActiveHour;

      if(isOpen){

        bar.classList.remove('bnst-closed');

      } else {

        bar.classList.add('bnst-closed');

      }

    }

    bnstUpdateServiceStatus();

    setInterval(
      bnstUpdateServiceStatus,
      60000
    );

    document.addEventListener(
      'keydown',
      function(ev){

        if(ev.key !== 'Escape'){
          return;
        }

        var overlay =
          document.getElementById('bnstSupportOverlay');

        if(
          overlay &&
          overlay.classList.contains('bnst-open')
        ){
          window.bnstSupportToggle(false);
        }

      }
    );

    window.addEventListener(
      'resize',
      function(){

        var els = bnstGet();

        if(!els.overlay || !els.launcher){
          return;
        }

        if(
          !els.overlay.classList.contains('bnst-open')
        ){
          return;
        }

        els.launcher.classList.add('bnst-hide');

      }
    );

  })();
